import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { NetworkHelper } from '@wm-libs/core';
import { AccessTokenInfo, AccessTokenListItem, AccessTokenPermission } from '../interfaces/access-token.interface';

@Injectable({
  providedIn: 'root',
})
export class PoolAccessTokenService {
  readonly accessTokenUrl = environment.poolApi + '/access-token';
  readonly accessTokensUrl = environment.poolApi + '/access-tokens';

  constructor(private networkHelper: NetworkHelper) {}

  getAccessTokensList(): Observable<AccessTokenListItem[]> {
    return this.networkHelper.get<AccessTokenListItem[]>(`${this.accessTokensUrl}`);
  }

  createAccessToken(label: string, permissions: AccessTokenPermission[]): Observable<AccessTokenListItem> {
    return this.networkHelper.post<AccessTokenListItem>(`${this.accessTokenUrl}/create`, { label, permissions });
  }

  editAccessToken(id: number, label: string, enabled: boolean, permissions: AccessTokenPermission[]): Observable<AccessTokenListItem> {
    return this.networkHelper.put<AccessTokenListItem>(`${this.accessTokenUrl}/${id}`, { label, enabled, permissions });
  }

  deleteAccessToken(id: number): Observable<AccessTokenListItem> {
    return this.networkHelper.delete<AccessTokenListItem>(`${this.accessTokenUrl}/${id}`, {});
  }

  getAccessTokenInfo() {
    return this.networkHelper.get<AccessTokenInfo>(`${this.accessTokenUrl}`);
  }

  getAccessTokenBalance() {
    return this.networkHelper.get<number>(`${this.accessTokenUrl}/balance`);
  }
}
